import script from "./AppFormGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppFormGroup.vue?vue&type=script&lang=ts&setup=true"

import "./AppFormGroup.vue?vue&type=style&index=0&id=7ebf5618&lang=css"

const __exports__ = script;

export default __exports__